import { Navigate, Outlet } from 'react-router-dom';

import { Flex, Image } from '@chakra-ui/react';

import backgroundLogo from 'app/assets/svg/backgroundLogo.svg';
import fullLogoBlack from 'app/assets/svg/fullLogoBlack.svg';

import useAuthContext from 'app/hooks/useAuthContext';
import useSignOut from 'app/hooks/useSignOut';
import { useAuthenticationStore } from 'app/store';

import { getBlankPath } from 'app/utils/routes';

function LoginLayout() {
  const { user } = useAuthContext();
  const isContextSwitch = useAuthenticationStore(
    (state) => state.authenticationData.isContextSwitch
  );

  // TODO: Temporarily signing out when not signed in as an ASLAN_ADMIN
  const { mutate: signOut } = useSignOut(user?.role);

  if (user && !isContextSwitch) {
    if (user?.role === 'ASLAN_ADMIN') {
      signOut();
    }

    return <Navigate to={getBlankPath()} replace />;
  }

  return (
    <Flex
      minH="100vh"
      align="center"
      justify="left"
      bgGradient="linear(to-r, brand.darkPurple 7.24%, brand.grayishBlack 115.47%)"
    >
      <Image src={backgroundLogo} position="absolute" right={0} />
      <Flex
        flexDirection="column"
        flexGrow={1}
        ml={{ base: '30px', md: '130px' }}
        mr={{ base: '30px', md: 'auto' }}
        maxW="500px"
        rounded="lg"
        bg="white"
        boxShadow="lg"
        py="40px"
        px="60px"
        zIndex={1}
      >
        <Image src={fullLogoBlack} alt="Aslan" width={110} />
        <Outlet />
      </Flex>
    </Flex>
  );
}

export default LoginLayout;
